import React from 'react';

import {
  Grid,
  Typography,
} from '@material-ui/core';

import { getMoney, getItemValue } from '../helpers';
import CustomPair from '../pair';
import { STYLES } from '../../constants';

export default function ComponentAccount({ ...props }) {

  return (
    <>
      <Typography
        align="center"
        color="primary"
        variant="h5"
      >
        {'Minha conta'}<br></br>
      </Typography>
      { props.state && (
        <Grid container={true} direction='column'>
            <br></br>
            <Grid item><CustomPair first="Email" second={getItemValue(props.state, ['user', 'email'], '')} /></Grid>
            <Grid item><CustomPair first="Conta" second={getItemValue(props.state, ['id'], '')} /></Grid>
            <Grid item><CustomPair first={"Saldo"} second={getMoney(props.state, ['saldo'])} style={STYLES.MONEY.POSITIVE} /></Grid>
          </Grid>
        )
      }
    </>
  )
}
